// for server url
// export const ABSOLUTE_URL = "https://d3lpwaalvq5zvi.cloudfront.net/"
export const ABSOLUTE_URL = process.env.REACT_APP_DOMAIN + "/"
export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB in bytes


